<template>
  <div class="d-container" :class="{'d-container--active': isDropDown}">
    <div class="d-select__selected" @click="setDropdown" v-on-clickaway="setDropdownFromClick" ref="d_parent">
      <h5>{{ selectedUser ? selectedUser.name : userName }}</h5>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon tw-icon-cheveron-selection">
        <path fill-rule="evenodd"
              d="M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
              class="secondary"></path>
      </svg>
    </div>
    <div class="d-select__dropdown" v-if="isDropDown" ref="d_child"
         :class="{'d-dropdown--animate': isPopperReady, 'd-dropdown--show': isPopperDone}">
      <div class="d-select-input" @click.stop>
        <span class="icon-search5"></span>
        <input type="search" v-model="search" ref="inputsearch">
      </div>
      <ul ref="d_list">
        <li v-for="user in usersQuery" @click="selectUser(user.id)"
            :ref="selectedUser && user.id === selectedUser.id ? 'selectedUser' : null"
            :class="{'user--is-selected': selectedUser && user.id === selectedUser.id}">
          <p>{{ user.name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import {createPopper} from '@popperjs/core'

export default {
  mixins: [clickaway],
  props: {
    preSelectedUserId: {
      default: 13
    },
    userName: {
      default: ''
    },
    path: {
      type: String,
      default: 'tasks'
    }
  },
  data () {
    return {
      selectedUserId: null,
      isDropDown: false,
      isPopperDone: false,
      isPopperReady: false,
      search: ''
    }
  },
  computed: {
    selectedUser () {
      const idx = this.users.findIndex(user => user.id === this.selectedUserId * 1)
      return this.users[idx]
    },
    users () {
      return this.$store.state.allUsers
    },
    usersSorted () {
      return this.$store.getters.usersSortedOnName
    },
    usersQuery () {
      return this.usersSorted.filter(item => {
        return item.name !== null ? item.name.match(new RegExp(this.search, 'i')) : ''
      })
    }
  },
  methods: {
    selectUser (id) {
      this.selectedUserId = id
      window.location = '/users/' + id + '/' + this.path + '#'
    },
    createPopper () {
      this.isPopperReady = false
      this.isPopperDone = false
      let dChild = this.$refs.d_child
      let dParent = this.$refs.d_parent
      if (this.appendToBody) {
        document.getElementById('djs-body-click').appendChild(dChild)
      }
      createPopper(dParent, dChild, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 0]
            }
          }
        ]
      })
      setTimeout(_ => {
        this.isPopperReady = true
        this.isPopperDone = true
      }, 0)
      setTimeout(_ => {
        this.scrollToSelectedUser()
      }, 200)
    },
    scrollToSelectedUser () {
      if (this.$refs.inputsearch) {
        this.$refs.inputsearch.focus()
      }
      const list = this.$refs.d_list
      const selectedRef = this.$refs.selectedUser
      const selectedEl = Array.isArray(selectedRef) ? selectedRef[0] : selectedRef
      if (list && selectedEl) {
        // Center the selected user within the scrollable list
        list.scrollTop = selectedEl.offsetTop - (list.clientHeight / 2) + (selectedEl.clientHeight / 2)
      }
    },
    setDropdown () {
      this.isDropDown = !this.isDropDown
      if (this.isDropDown) {
        setTimeout(_ => {
          this.createPopper()
        }, 0)
      } else {
        this.isPopperReady = false
        this.isPopperDone = false
        this.search = ''
      }
    },
    setDropdownFromClick () {
      if (!this.isDropDown) {
        return
      }
      this.setDropdown()
    }
  },
  mounted () {
    if (this.preSelectedUserId) {
      this.selectedUserId = this.preSelectedUserId
    }
    this.$store.dispatch('getUsers')
  },
  beforeDestroy () {
    // remove the dropdown from the DOM
    let dChild = this.$refs.d_child
    if (dChild) {
      dChild.remove()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-container {
  position: relative;
}

.d-select__selected {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  padding: 0.5rem 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  cursor: pointer;
}

.d-container--active .d-select__selected {
  min-width: 250px;
}

.d-select__selected h5 {
  padding-right: 0.5rem;
}

.d-container.d-container--active .d-select__selected {
  background: #ffffff;
}

.tw-icon {
  width: 1.3rem;
}

.d-container--active .d-select__selected {
  border-color: var(--blue);
  border-radius: 4px 4px 0 0;
}

.d-select__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% - 3px);
  left: 0;
  background-color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0 0 0.5rem 0;
  min-width: 100px;
  width: 250px;
  user-select: none;
  opacity: 0;
  margin-top: -10px !important;
  border: 1px solid var(--blue);
  border-width: 0 1px 1px 1px;
  border-radius: 0 0 4px 4px;
}

.d-select__dropdown.d-dropdown--animate {
  transition: opacity 0.15s, margin-top 0.15s;
}

.d-select__dropdown.d-dropdown--show {
  opacity: 1;
  margin-top: 0px !important;
}

.d-select__dropdown .d-select-input {
  position: relative;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0.5rem;
}

.d-select-input > span {
  position: absolute;
  top: calc(0.5rem + 0.65rem);
  left: calc(0.5rem + 1rem);
  color: var(--grey);
  font-size: 1.2rem;
}

.d-select__dropdown input {
  padding: 0.5rem 0.5rem 0.5rem 2.5rem;
  font-size: 13px;
  font-weight: normal;
  border-color: var(--border-color);
  box-sizing: border-box;
}

.d-select__dropdown input:focus {
  border-color: var(--blue);
}

.d-select__dropdown > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  max-height: 40vh;
  overflow-y: auto;
}

.d-select__dropdown > ul > li {
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
}

.d-select__dropdown > ul > li > p {
  width: 100%;
  display: block;
  padding: 0.5rem 1rem;
  color: var(--dark-blue);
}

.d-select__dropdown > ul > li:hover {
  background-color: #f5f6f7;
}

.d-select__dropdown > ul > li.user--is-selected {
  background-color: var(--blue);
  color: #ffffff;
}

.d-select__dropdown > ul > li.user--is-selected p {
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// SelectUser.vue?03d39d12